module.exports = "<p>\n  dialog-example works!\n</p>\n"